export enum ObjectResponseType {
  OBJECT = 'object',
  LIST = 'list',
  SUCCESS = 'success',
}

/* eslint-disable camelcase */
export type ObjectResponse<T> = {
  responded_at: string;
  object: ObjectResponseType.OBJECT;
  data: T;
};

export type ListResponse<T> = {
  responded_at: string;
  object: ObjectResponseType.LIST;
  count?: number;
  data_count: number;
  data: T[];
};

export type PaginatedObjectResponse<T> = {
  responded_at: string;
  next_item: string | number | null;
  object: ObjectResponseType.OBJECT;
  data: T;
};

export type PaginatedListResponse<T> = {
  responded_at: string;
  last_item_identifier: string | number | null;
  object: ObjectResponseType.LIST;
  data_count: number;
  data: T[];
};

export type NoContentResponse = {
  data: never;
};

export type SuccessResponse<T = Record<never, never>, M extends string = string> = {
  responded_at: string;
  object: ObjectResponseType.LIST;
  data_count: 1;
  data: [
    {
      object: ObjectResponseType.SUCCESS;
      resource: T;
      message: M;
    }
  ];
};

export type CreatedResponse<T> = {
  data: SuccessResponse<T, 'Resource created successfully'>;
};
